// extracted by mini-css-extract-plugin
export default {"socialLoginButton":"OpenIDLoginButton_socialLoginButton__fy5kJ","propertyRadarLogo":"OpenIDLoginButton_propertyRadarLogo__PIAMT"};